import React, {Component} from "react";
import {OverlayTrigger, Popover} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class PopoverTooltip extends Component {

  buttonColor= this.props.buttonColor || '#426DA0F5';
  icon = this.props.icon || 'info-circle';

  popoverOverlayWithTitle = (
    <Popover id={'popoverTooltip-'.concat(Math.random().toString())}>
      <Popover.Title>{this.props.title}</Popover.Title>
      <Popover.Content style={{whiteSpace: 'pre-wrap'}}>{this.props.content}</Popover.Content>
    </Popover>
  );

  popoverOverlay = (
      <Popover id={'popoverTooltip-'.concat(Math.random().toString())}>
        <Popover.Content>{this.props.content}</Popover.Content>
      </Popover>
  );

  popoverTrigger = (this.props.trigger) ? this.props.trigger : ['hover', 'focus'];
  content = (this.props.children) ? this.props.children : (<FontAwesomeIcon className={'info-circle-icon'}
                                                                            icon={this.icon}
                                                                            color={this.buttonColor}
                                                                            onClick={e => e.stopPropagation()}
                                                                            size={'lg'}/>);
  placement = (this.props.placement) ? this.props.placement : 'auto';

  render() {
    return (
      <OverlayTrigger placement={this.placement}
                      trigger={this.popoverTrigger}
                      overlay={(this.props.title === '')?this.popoverOverlay:this.popoverOverlayWithTitle}
                      delay={this.props.delay}
                      container={this.props.containerRef?this.props.containerRef.current:null}
                      // transition={false} //Add this to remove findDOMNode deprecated message
                      rootClose>
        {(props) => <div className={this.props.className} style={{width: 'fit-content', display: 'inline'}} {...props}>{this.content}</div>}
      </OverlayTrigger>
    );
  }

}

export default PopoverTooltip;
